import { Koi } from '@ksyos/koi';
import type { ISchemaContainer } from './schemaContainer';

export interface IInsuranceHistoryGetSourceValidated {
    birthDate: string;
    houseLetter: string | null;
    houseNumber: string | null;
    houseNumberSuffix: string | null;
    identifierInsurance: string | null;
    identifierSocialSecurity?: string | null;
    zip: string | null;
}

export const insuranceHistoryGetSourceSchema: ISchemaContainer<IInsuranceHistoryGetSourceValidated> = {
    schema: Koi.object({
        birthDate: Koi.koi().date(),
        houseLetter: Koi.string().max(255).allow(null),
        houseNumber: Koi.string().max(255).allow(null),
        houseNumberSuffix: Koi.string().max(255).allow(null),
        identifierInsurance: Koi.string().max(255).allow(null),
        identifierSocialSecurity: Koi.string().elfproef().allow(null).optional(),
        zip: Koi.string().max(255).allow(null),
    }).options({ convert: false, presence: 'required' }),
};

export const activeInsuranceSchema: ISchemaContainer<IActiveInsurance> = {
    schema: Koi.object({
        endDate: Koi.koi().date().allow(null).optional(),
        id: Koi.string().uuid().optional(),
        insurancePolicyNumber: Koi.string().max(255),
        insurer: Koi.object({
            name: Koi.string().max(255).allow(null),
        }).optional(),
        startDate: Koi.koi().date(),
        uzovi: Koi.object({
            code: Koi.string().max(255),
            name: Koi.string().max(255).optional(),
        }),
        uzoviId: Koi.string().uuid().optional(),
    }).options({ convert: false, presence: 'required' }),
};

export interface IActiveInsurance {
    endDate?: Date;
    id?: string;
    insurancePolicyNumber: string;
    insurer?: {
        name: string | null;
    };
    startDate: Date;
    uzovi: {
        code: string;
        name?: string;
    };
    uzoviId?: string;
}
